var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"value":_vm.value,"placeholder":"请选择","clearable":""},on:{"change":_vm.fn}},_vm._l((_vm.channelOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }